"use client";

import React, { Suspense } from "react";
import Image from "next/image";
import cx from "classnames";
import { useTranslations } from "next-intl";

import Link from "@/components/Link";

import CtaInstantConsultation from "@/components/CtaInstantConsultation";
import SearchInputButton from "@/components/SearchInputButton";
import Menu from "@/components/Menu";
import HamburgerIcon from "@/components/HamburgerIcon";
import ExtendNav from "@/components/ExtendNav";
import PropertySearchModal from "@/components/PropertySearchModal";

import UserProfileLink from "@/components/UserProfileLink";
import useHeader from "./useHeader";

const Header = ({ showInstantConsultation = true, barClassName = "", user }) => {
  const {
    closeSearchModal,
    isMenuOpen,
    isSearchOpen,
    openSearchModal,
    setIsMenuOpen,
    toggleMobileNav,
    searchModalMode,
    setSearchModalMode,
  } = useHeader();

  return (
    <header
      className={cx("relative w-full h-12 bg-white z-999", barClassName)}
      style={{ zIndex: 99 }}
    >
      <div className="h-12 px-4 relative z-50">
        <div className="h-full mx-auto flex gap-2 justify-between items-center">
          <div className="flex md:flex-1">
            <Link
              href="/"
              className="hidden md:block h-8 aspect-1315/281 shrink-0"
              prefetch={false}
            >
              <Image
                src="/assets/images/logo-black.svg"
                alt="Inside Dubai Estate logo"
                className="w-full h-full"
                width={1315}
                height={281}
              />
            </Link>
          </div>

          <div className="flex-1 h-10 md:min-w-96">
            <Suspense>
              <SearchInputButton
                onClick={() => {
                  setSearchModalMode("location");
                  openSearchModal();
                }}
                onFilterClick={() => {
                  setSearchModalMode("filters");
                  openSearchModal();
                }}
              />
            </Suspense>
          </div>

          <div className="flex md:flex-1 gap-1 md:gap-2 items-center justify-end">
            {showInstantConsultation && <CtaInstantConsultation />}

            <div className="relative w-9 h-9 -mr-2 z-50">
              <HamburgerIcon onClick={toggleMobileNav} active={isMenuOpen} color="#000" />
            </div>

            <UserProfileLink user={user} />
          </div>
        </div>
      </div>

      <ExtendNav isOpen={isMenuOpen} duration={500} contentContainerClass="pt-12!" theme="light">
        <Menu onLinkClick={toggleMobileNav} isOpen={isMenuOpen} theme="light" />
      </ExtendNav>

      <PropertySearchModal
        show={isSearchOpen}
        onClose={closeSearchModal}
        showFilters={searchModalMode === "filters"}
        // onReset={() => {
        //   closeSearchModal();
        //   resetForm();
        // }}
        // onSubmit={() => {
        //   closeSearchModal();
        //   handleSubmit();
        // }}
      />
    </header>
  );
};

export default Header;
